// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("./Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function fromString(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, (function (param) {
                switch (param) {
                  case "disabled" :
                      return /* Disabled */2;
                  case "json" :
                      return /* Json */0;
                  case "traditional" :
                      return /* Traditional */1;
                  default:
                    return ;
                }
              }), param);
}

var decode = Curry._1(Json.Decode.variantFromString, fromString);

var ConsoleLogFormat = {
  fromString: fromString,
  decode: decode
};

function json(param_0) {
  return {
          TAG: /* Json */0,
          _0: param_0
        };
}

function exn(param_0) {
  return {
          TAG: /* Exn */1,
          _0: param_0
        };
}

function message(param_0) {
  return {
          TAG: /* Message */2,
          _0: param_0
        };
}

function encode(json) {
  switch (json.TAG | 0) {
    case /* Json */0 :
        return Json.Encode.object_({
                    hd: [
                      "json",
                      JSON.stringify(json._0)
                    ],
                    tl: /* [] */0
                  });
    case /* Exn */1 :
        var exn = json._0;
        return Json.Encode.object_({
                    hd: [
                      "exception",
                      Json.Encode.object_({
                            hd: [
                              "name",
                              Json.Encode.optional((function (prim) {
                                      return prim;
                                    }), exn.name)
                            ],
                            tl: {
                              hd: [
                                "message",
                                Json.Encode.optional((function (prim) {
                                        return prim;
                                      }), exn.message)
                              ],
                              tl: {
                                hd: [
                                  "stack",
                                  Json.Encode.optional((function (prim) {
                                          return prim;
                                        }), exn.stack)
                                ],
                                tl: /* [] */0
                              }
                            }
                          })
                    ],
                    tl: /* [] */0
                  });
    case /* Message */2 :
        return Json.Encode.object_({
                    hd: [
                      "message",
                      json._0
                    ],
                    tl: /* [] */0
                  });
    
  }
}

function toConsoleFormattedString(json) {
  switch (json.TAG | 0) {
    case /* Json */0 :
        return JSON.stringify(json._0, null, 2);
    case /* Exn */1 :
        var exn = json._0;
        return Curry._3(Relude_Array.foldLeft, (function (prim, prim$1) {
                      return prim + prim$1;
                    }), "", Relude_Array.intersperse(" | ", [
                        Relude_Option.getOrElse("", Relude_Option.map((function (a) {
                                    return "exception name: " + a;
                                  }), exn.name)),
                        Relude_Option.getOrElse("", Relude_Option.map((function (a) {
                                    return "exception message: " + a;
                                  }), exn.message)),
                        Relude_Option.getOrElse("", Relude_Option.map((function (a) {
                                    return "exception stack: " + a;
                                  }), exn.stack))
                      ]));
    case /* Message */2 :
        return json._0;
    
  }
}

var Data = {
  json: json,
  exn: exn,
  message: message,
  encode: encode,
  toConsoleFormattedString: toConsoleFormattedString
};

function encode$1(param) {
  var startTimestamp = param.startTimestamp;
  var endTimestamp = param.endTimestamp;
  return Json.Encode.object_({
              hd: [
                "data",
                encode(param.data)
              ],
              tl: {
                hd: [
                  "duration",
                  Relude_Float.roundAsInt(endTimestamp.getTime() - startTimestamp.getTime())
                ],
                tl: {
                  hd: [
                    "endTimestamp",
                    Json.Encode.date(endTimestamp)
                  ],
                  tl: {
                    hd: [
                      "prefix",
                      Json.Encode.optional((function (prim) {
                              return prim;
                            }), param.prefix)
                    ],
                    tl: {
                      hd: [
                        "startTimestamp",
                        Json.Encode.date(startTimestamp)
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

var Entry = {
  encode: encode$1
};

function encode$2(param) {
  return Json.Encode.object_({
              hd: [
                "context",
                Json.Encode.list(function (prim) {
                        return prim;
                      })(Relude_List.reverse(param.context))
              ],
              tl: {
                hd: [
                  "entries",
                  Json.Encode.list(encode$1)(Relude_List.reverse(param.entries))
                ],
                tl: /* [] */0
              }
            });
}

function append(param, param$1) {
  return {
          context: Relude_List.concat(param$1.context, param.context),
          entries: Relude_List.concat(param$1.entries, param.entries)
        };
}

var Monoid_empty = {
  context: /* [] */0,
  entries: /* [] */0
};

var Monoid = {
  empty: Monoid_empty,
  append: append
};

exports.ConsoleLogFormat = ConsoleLogFormat;
exports.Data = Data;
exports.Entry = Entry;
exports.encode = encode$2;
exports.Monoid = Monoid;
/* decode Not a pure module */
